module.exports = __webpack_public_path__ + "img/1970East-058_WEB-min.85e1f3ee.jpg";